export default {
    citizenshipDocDateFields: ['issuedDate', 'expiringDate'],
    documentTypeSelects: ['Drivers License', 'Green Card', 'Passport', 'Visa'],
    driversLicenseDocumentType: 'Drivers License',
    greenCardDocumentType: 'Green Card',
    passportDocumentType: 'Passport',
    visaDocumentType: 'Visa',
    visaTypeSelects: ['B1', 'B2', 'H1B', 'H2B', 'O1', 'P1', 'P4', 'WX-1']
}